import { Button, Snackbar, Portal } from '@mui/material';
import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import * as serviceWorker from './serviceWorkerRegistration';

const AppUpdate = ({ children }) => {
  const [showReload, setShowReload] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  const onSWUpdate = (registration) => {
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  };

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      serviceWorker.register({ onUpdate: onSWUpdate });
    }
  }, []);

  const reloadPage = () => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
    setShowReload(false);
    window.location.reload(true);
  };

  return (
    <>
      {children}
      <Portal>
        <Snackbar
          open={showReload}
          message="A new version is available!"
          onClick={reloadPage}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          action={
            <Button color="inherit" size="small" onClick={reloadPage}>
              Reload
            </Button>
          }
        />
      </Portal>
    </>
  );
};

export default AppUpdate;
